import { useEffect } from 'react';
import { TStorage } from '../../types';
import useCoctails from './useCoctails';
import useGames from './useGames';

const useMedia = () => {
  const { coctails } = useCoctails();
  const { gameCards, onGetGamesCard } = useGames();

  useEffect(() => {
    onGetGamesCard();
  }, []);

  const onUseMedia = (type: keyof typeof TStorage, name: string) => {
    let isUsed = false;

    if (type === 'IMAGE' || type === 'CONTENT') {
      coctails?.forEach(item => {
        if (type === 'IMAGE' && item?.media?.posterName === name) {
          isUsed = true;
        } else if (type === 'CONTENT' && item?.media?.videoName === name) {
          isUsed = true;
        }
      });
      return isUsed;
    } else if (type === 'AUDIO') {
      gameCards?.forEach(item => {
        if (item.musicQuizTrackName === name) {
          isUsed = true;
        }
      });
      return isUsed;
    }
  };

  return { onUseMedia };
};

export default useMedia;
